module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_307285.d1ea3620.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetInRecargas/FormatoSimplificado_307285.pdf
// module id = 825
// module chunks = 0